<template>
	<div v-if="finishedLoading">
		<div class="notificacoes">
			<div class="row tit_page">
				<div class="col-12">
					<div class="float-left title">
						<h1>Notificações</h1>
						<router-link v-if="IsInvestidor()" :to="{path:'perfil/configuracoes'}" class="btn btn-secondary" >Editar suas Configurações</router-link>
					</div>
					<div class="back float-right">
						<a @click="$router.go(-1)" href="javascript:;" title="Voltar">
							<i>&nbsp;</i> voltar
						</a>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
			<hr class="divider">
			<div class="row list-notifications" v-if="notificacoes.length > 0">
				<div class="col-12" v-for="notificacao in notificationsAux">
					<router-link :to="formatUrl(notificacao.Url)" class="" :title="notificacao.Titulo" :event="''" @click.native.prevent="changeStatus(notificacao._id, notificacao.Url)">
						<div class="item" :class="verifyStatus(notificacao.Status)">
							<div class="row">
								<div class="col-12 col-md-5 col-lg-5 title">
									<!-- STATUS DA NOTIFICAÇÃO | Visualizado - success | Publicado - primary | Atencao - warning | Atrasado - danger -->
									<!-- icon-info para notificacoes genericas -->
									<span v-if="notificacao.Tipo === 'Pagamento'" class="icon icon-coin rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
									<span v-else-if="notificacao.Tipo === 'Solicitacao'" class="icon icon-doc rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
									<span v-else-if="notificacao.Tipo === 'Boleto'" class="icon icon-bar rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
									<span v-else class="icon icon-infos rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
									<!-- ::::::::::::::::::::: -->
									<div>
									<h5>{{notificacao.Titulo}}</h5>
									<p><span>{{convertDate(notificacao.Created,notificacao.Updated, notificacao.Status)}}</span></p>
									</div>
								</div>
								<div class="col-12 col-md-7 col-lg-7">
									<div class="entry">
										<p>{{notificacao.Descricao}}</p>
									</div>
								</div>
							</div>
						</div>
					</router-link>
				</div>
				<!-- final mensagem -->
				<!-- INICIO PAGINAÇAO -->
				<!-- <nav class="wallet__pagination col-12">
						<ul class="pagination">
								<li class="page-item">
										<a class="page-link" :disabled="indexPage == 1" v-on:click="goPrevious(indexPage)">Voltar</a>
								</li>
								<li class="page-item" v-for="(pag, index) in pags" :class="{'active': activePagination(index+1)}">
									<a class="page-link" v-on:click="pagination(index)">
											{{index + 1}}
											<span class="sr-only">{{index}}</span>
									</a>
								</li>
								<li class="page-item">
										<a class="page-link" :disabled="indexPage == pags" v-on:click="goNext(indexPage)">Avançar</a>
								</li>
						</ul>
				</nav> -->
				<Pagination
                    :paginasTotais="this.pags"
                    :paginaAtual="this.indexPage"
                    :navigate="(route)=>this.pagination(route-1)"
                />
				<!-- FINAL PAGINAÇÃO -->
			</div>
			<!-- CASO NAO TENHA NOTIFICACOES -->
			<div class="d-flex justify-content-center align-items-center dashboard" v-else>
				<div class="dashboard__complete">
					<div class="row">
							<div class="col-12 text-center">
									<h1>Você ainda não possui nenhuma notificação</h1>
							</div>
					</div>
				</div>
		 </div>
		 <!-- :::::::::::::::::::::::::: -->
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import ApiClient from '../utils/api-client'
import Pagination from '@/components/Pagination';
import * as mutationTypes from '@/store/mutation-types.js'
import Masker from '@/utils/masker'

    export default {
        data() {
            return {
                notificacoes: [],
								notificationsAux: null,
                finishedLoading: false,
								statusGo: false,
								indexPage: 1,
            }
        },
				computed: {
					pags: function() {
            let pagsRelative = (this.notificacoes.length / 10).toString().split('.');
            return parseInt(pagsRelative[1]) <= 4 ? Math.round(this.notificacoes.length / 10 + 1) : Math.round(this.notificacoes.length  / 10)
          }
				},
		components: {
			Pagination
		},
        methods: {
					IsInvestidor(){
		          return document.URL.indexOf("investimentos") != -1;
		      },
            formatUrl(url) {
                let urlForm;

                if(url.indexOf("/") !== 0) {
                    urlForm = url.replace(/^/gm, "/");
                } else {
                    urlForm = url;
                }

                return urlForm;
            },
            verifyStatus(status) {
                let bgClass
                switch(status) {
                    case 'Publicado':
                    bgClass = 'bg-primary';
                    break;

                    case 'Atencao':
                    bgClass = 'bg-warning';
                    break;

                    case 'Atrasado':
                    bgClass = 'bg-danger';
                    break;

                    case 'Visualizado':
                    bgClass = 'bg-success';
                    break;
                }

                return bgClass;
            },
            changeStatus(id, url) {
                let status = "Visualizado";

                if(!this.statusGo) {
                    ApiClient.changeStatusNotification(id, status)
										.then((response)=>{
											if(response.status === 200) {
		                    this.Atualizar(url);
		                  }
		                })
                }
            },
						pagination(index) {
	            let numberPage = index * 10;
	            let aux = [];
	            let counter = 0;

	            this.indexPage = index + 1;

	            for(let i = numberPage; i < this.notificacoes.length; i++) {
	              if(counter < 10) {

					//Não mostrando notificações que estão "Deletadas" para o cliente. As mesmas se encontram no banco com o status deletado.
					if(this.notificacoes[i].Status != "Deletado") {
						aux.push(this.notificacoes[i]);
					}
	
	                counter++;
	              } else {
	                break;
	              }
	            }

	            this.notificationsAux = aux;
	          },
						activePagination(index) {
	            return this.indexPage === index
	          },
						goPrevious(index) {
	            let ind = (index === 2)? 0 : index - 2;

	            this.pagination(ind);
	          },
	          goNext(index) {
	            let ind = index;
	            this.pagination(ind);
	          },
            convertDate(dateCreate,dateUpdate, status) {
                let today = new Date();
                let timeStampToday = Math.round(today.getTime()/ 1000);
                let h = today.getHours();
                let m = today.getMinutes();
                let s = today.getSeconds()
				let arrayDate = Masker.maskIsoDate(dateCreate).split('/')
				let arrayDateUP = Masker.maskIsoDate(dateUpdate).split('/')
                let objDate   = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
                let timeStampDate = Math.round(objDate.getTime() / 1000);
                let hours   = ((timeStampToday - timeStampDate) / 3600);
                let days    = parseInt(hours / 24);
                let msg;

                if(status === 'Visualizado') {
									msg = `Enviado em ${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]} - Visualizado em  ${arrayDateUP[0]}/${arrayDateUP[1]}/${arrayDateUP[2]}`
								} else if(days <= 0) {
                    msg = 'Enviado Hoje';
                } else if(days <= 4) {
									msg = `Enviado há ${days} dias - ${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]}`;
								} else {
									msg = `Enviado em: ${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]}`;
								}

                return msg;
			},
						Atualizar(url) {
		          // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
		          ApiClient.getUser()
		          .then(user => {ApiClient.getNotificationsUser(user._id)
		          .then(notifications => {
		              this.notificacoes = notifications;

		              notifications.forEach(value => {
		                  if(value.Status !== 'Visualizado') {
		                      this.hasNotify = true;
		                      return true;
		                  }
		              });

									if(this.notificacoes.length <= 0) {
		                this.hasNotify = false;
		              }

		              this.$router.push(this.formatUrl(url));
		              this.finishedLoading = true;
		          })})
		          .catch(() =>{
		              this.finishedLoading = true;
		          })
		        }
        },
        beforeCreate() {
             this.$store.commit(mutationTypes.START_LOADING)

            // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
            ApiClient.getUser()
            .then(user => {ApiClient.getNotificationsUser(user._id)
            .then(notifications => {
                this.notificacoes = notifications;

								this.pagination(0);
                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })})
            .catch(() =>{
                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        }
    }
</script>

<style lang="scss" scoped>
	.title {
		&{
			h1 {
				float: left;
			}

			a {
				float: left;
				margin-left: 1rem;
				margin-top: 5px;
		    text-transform: uppercase;
		    font-weight: bold;
		    font-size: 13px;
		    padding-left: 20px;
		    padding-right: 20px;
		    border: none;
		    background: #ccc;
			}
		}
	}

	h5 {
		color: #000;
	}
</style>



// WEBPACK FOOTER //
// src/views/Notifications.vue